
import { toast as sonnerToast } from 'sonner';
import { CheckCircle, AlertCircle, Info, X, RotateCcw } from 'lucide-react';

interface ToastOptions {
  title?: string;
  description?: string;
  duration?: number;
  action?: {
    label: string;
    onClick: () => void;
  };
  onUndo?: () => void;
}

export const enhancedToast = {
  success: (message: string, options?: ToastOptions) => {
    return sonnerToast(message, {
      description: options?.description,
      duration: options?.duration || 4000,
      icon: <CheckCircle className="w-4 h-4 text-green-500" />,
      action: options?.action ? {
        label: options.action.label,
        onClick: options.action.onClick,
      } : undefined,
    });
  },

  error: (message: string, options?: ToastOptions) => {
    return sonnerToast(message, {
      description: options?.description,
      duration: options?.duration || 6000,
      icon: <AlertCircle className="w-4 h-4 text-red-500" />,
      action: options?.action ? {
        label: options.action.label,
        onClick: options.action.onClick,
      } : undefined,
    });
  },

  info: (message: string, options?: ToastOptions) => {
    return sonnerToast(message, {
      description: options?.description,
      duration: options?.duration || 4000,
      icon: <Info className="w-4 h-4 text-blue-500" />,
      action: options?.action ? {
        label: options.action.label,
        onClick: options.action.onClick,
      } : undefined,
    });
  },

  actionWithUndo: (message: string, onUndo: () => void, options?: ToastOptions) => {
    return sonnerToast(message, {
      description: options?.description,
      duration: options?.duration || 8000,
      action: {
        label: 'Cofnij',
        onClick: onUndo,
      },
      icon: <RotateCcw className="w-4 h-4 text-orange-500" />,
    });
  },

  loading: (message: string) => {
    return sonnerToast.loading(message);
  },

  dismiss: (id: string | number) => {
    return sonnerToast.dismiss(id);
  },
};
